import React from 'react';
import { EmailLink } from './emailLink';
import { WebLink } from './webLink';

export const renderBlock = (block, key) => {
  if (typeof block === 'string') {
    return (
      <p key={key} className="privacy-text">
        {block}
      </p>
    );
  }

  if (block.list) {
    return (
      <ul key={key} className="privacy-list">
        {block.list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  }

  if (block.sub) {
    return (
      <div key={key} className="privacy-subsection">
        <h5 className="privacy-subsection-title">{block.sub}</h5>
        {block.content.map((child, i) => renderBlock(child, i))}
      </div>
    );
  }

  if (block.contact) {
    return (
      <div key={key} className="privacy-contact">
        {block.contact.map((row, i) => (
          <p key={i} className="privacy-text">
            {row.label && <span className="privacy-contact-label">{row.label} </span>}
            {row.email && <EmailLink email={row.email} />}
            {row.link && <WebLink url={row.link} />}
          </p>
        ))}
      </div>
    );
  }

  if (block.text) {
    return (
      <p key={key} className="privacy-text">
        {block.text}
        {block.email && <EmailLink email={block.email} />}
        {block.suffix}
      </p>
    );
  }

  return null;
};
